export const dispatchConductricsEvent = () => {
  window.dispatchEvent(
    new CustomEvent("ConductricsStateChange", { detail: "vs-VeqsqJUkLm" }),
  );
};
